export default "__VITE_ASSET__E47iADMJ__"